import { render, staticRenderFns } from "./InvoicesCorrect.vue?vue&type=template&id=ec5a443e"
import script from "./InvoicesCorrect.vue?vue&type=script&lang=js"
export * from "./InvoicesCorrect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports